import { render, staticRenderFns } from "./useDeptTree.vue?vue&type=template&id=53a334cb&scoped=true&"
import script from "./useDeptTree.vue?vue&type=script&lang=js&"
export * from "./useDeptTree.vue?vue&type=script&lang=js&"
import style0 from "./useDeptTree.vue?vue&type=style&index=0&id=53a334cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a334cb",
  null
  
)

export default component.exports